export const SETTINGS_ACCESS_STATUS_TYPES_NAME_MAX_LENGTH = 75;
export const SETTINGS_ACCESS_STATUS_TYPES_DESCRIPTION_MAX_LENGTH = 150;
